export default __webpack_public_path__ + "static/media/poppins-semibold.0172289b.woff";